import { render, staticRenderFns } from "./UnitEditAudit.vue?vue&type=template&id=38c50e0d"
import script from "./UnitEditAudit.vue?vue&type=script&lang=js"
export * from "./UnitEditAudit.vue?vue&type=script&lang=js"
import style0 from "./UnitEditAudit.vue?vue&type=style&index=0&id=38c50e0d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports